export enum NotifierTypeEnum {
  None = 0,
  LoggedIn = 1,
  LoggedOut = 2,
  NewReviewAdded = 3,
  CurrentLocationChanged = 4,
  SelectedLocationChanged = 5,
  SelectedLocationDetailsChanged = 6,
  LocationPermissionStatusChanged = 7,
}
